import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import getCookieByName from "src/functions/getCookieByName";
import { getDataClient } from "src/functions/useGetDataClient";
import { ApiLoggedUser } from "src/types/ApiLoggedUser";

export interface UserContextInterface {
  loggedUser: ApiLoggedUser;
  refetch: () => void;
  loading: boolean;
}

export const UserContext = createContext<UserContextInterface>(null);

type Props = {
  children: ReactNode;
};

export function UserContextProvider({ children }: Props) {
  const isAuthorized = getCookieByName(`auth-token`);
  const [loggedUser, setLoggedUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const { client } = await getDataClient();

    setLoggedUser(client);
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contextValue = useMemo(
    () => ({
      loggedUser,
      refetch,
      loading,
    }),
    [loggedUser, refetch, loading]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}
